import { utils } from "pixi.js";
import { ITextInput } from "./ITextInput";
import { AndroidTextInput } from "./AndroidTextInput";
import { TextInput } from "./TextInput";
import { InputOptions } from "@pixi/ui";

export function textInputFactory(options: InputOptions, inputMode: string = "text"): ITextInput {
    if (utils.isMobile.android.device) {
        return new AndroidTextInput(options, inputMode);
    }
    return new TextInput(options, inputMode);
}
